import { useTranslation } from 'react-i18next';
import RuleAction from '../RuleAction';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import { addAction } from 'components/Rules/helpers/ruleUpdates';
import RuleActionsFields from 'components/Rules/RuleActions';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import type { TQuestionRule } from 'types/rules.types';

interface Props {
  rule: TQuestionRule;
}

const RuleActions = ({ rule }: Props) => {
  const { t } = useTranslation('Templates');
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <RuleActionsFields
      isReadOnly={isReadOnly}
      actions={rule.actions ?? []}
      renderAction={(action, actionIdx) => (
        <RuleAction key={action.id} rule={rule} action={action} actionIdx={actionIdx} />
      )}
      addLabel={t('question.ruleActions.addActionButton')}
      onAdd={() => dispatch(upsertQuestionRule({ questionId, rule: addAction(rule, 'JUMP_TO') }))}
    />
  );
};

export default RuleActions;
